/**
 * コモンクラス
 * @constructor
 */
 class Common {
  constructor() {
    this.init();
    this.initPageTop();
    this.initContactBanner();
  }
  /**
   * コモン
   */
  init() {
    // alert('Common.jsが読み込まれました');
  }

  /**
   * ページトップボタンの初期化
   */
  initPageTop() {
    const pagetopBtn = document.querySelector('.js-pagetop');
    if (!pagetopBtn) return;

    const footer = document.querySelector('.l-footer');
    const footerBottom = document.querySelector('.l-footer__bottom');
    const groupNav = document.querySelector('.l-footer__group-nav');
    const contactBanner = document.querySelector('.js-contact-banner');

    // ボタンの高さを取得（clampPx(64)の計算済み値）
    const getButtonHeight = () => {
      const height = parseFloat(getComputedStyle(pagetopBtn).height);
      return height;
    };

    // スクロールイベント
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // 300px以上スクロールしたら表示（トップボタンと同じ判定で contactBanner を表示）
      const shouldShow = scrollTop > 300;
      pagetopBtn.classList.toggle('is-show', shouldShow);
      if (contactBanner) contactBanner.classList.toggle('is-show', shouldShow);

      const isSP = window.innerWidth <= 750;
      const windowHeight = window.innerHeight;

      // フッターの下部（.l-footer__bottom）が画面に入ってきたら非表示にする（SPでも動作）
      if (footerBottom) {
        const footerBottomRect = footerBottom.getBoundingClientRect();
        const buttonHeight = getButtonHeight();
        const buffer = 16; // ボタンとフッターの間隔

        // フッター下部が画面に入ってきて、ボタンと被りそうな場所まで来たら隠す
        if (footerBottomRect.top < windowHeight - buttonHeight - buffer) {
          pagetopBtn.classList.remove('is-show');
        }
      }
      // フッターのグループナビの上部でボタンを止める（PC時のみ）
      if (!isSP && footer && groupNav) {
        const footerRect = footer.getBoundingClientRect();
        const groupNavRect = groupNav.getBoundingClientRect();

        // ボタンの高さの半分を取得（ボタンが真ん中で止まるように）
        const buttonHalfHeight = getButtonHeight() / 2;

        // グループナビがビューポートに入ったら、ボタンを固定位置からabsoluteに変更
        if (groupNavRect.top < windowHeight) {
          const stopPosition = groupNavRect.top + window.pageYOffset - buttonHalfHeight;
          pagetopBtn.style.position = 'absolute';
          pagetopBtn.style.top = `${stopPosition}px`;
          pagetopBtn.style.bottom = 'auto';
        } else {
          pagetopBtn.style.position = 'fixed';
          pagetopBtn.style.top = 'auto';
          pagetopBtn.style.bottom = '';
        }
      } else if (isSP) {
        // SP時は常に固定位置
        pagetopBtn.style.position = 'fixed';
        pagetopBtn.style.top = 'auto';
        pagetopBtn.style.bottom = '';
      }
    };

    // クリックイベント
    pagetopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });

    // スクロールイベントのリスナー追加
    window.addEventListener('scroll', handleScroll);
    // 初回実行
    handleScroll();
  }

  /**
   * お問い合わせバナーの初期化
   */
  initContactBanner() {
    const contactBanner = document.querySelector('.js-contact-banner');
    if (!contactBanner) return;

    // 初期表示状態はトップボタンと同期（以降は initPageTop のハンドラで制御）
    const isShown = (window.pageYOffset || document.documentElement.scrollTop) > 300;
    contactBanner.classList.toggle('is-show', isShown);
  }

}

export default Common;
